import axios from "axios";
import { getToken } from "../utils/auth";
import { apiBasePath } from "./config";

const apiRequest = axios.create({
  baseURL: apiBasePath,
  headers: {
    Authorization: `Bearer ${getToken()}`,
    "content-type": "application/json"
  }
});

export default apiRequest;
